var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('JModal',{attrs:{"before-close":_vm.onClose,"title":"Convidivi questo qr Code con i clienti","visible":_vm.showModal}},[_c('div',{staticStyle:{"display":"flex","align-items":"center","justify-content":"center"}},[_c('canvas',{ref:"qrcodePrint"})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }